import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-23350c1a")

_pushScopeId("data-v-23350c1a")
const _hoisted_1 = { class: "wizard-navigation" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Terug ")
const _hoisted_3 = { class: "progress" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "Voortgang", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = _resolveComponent("Button")
  const _component_ProgressBar = _resolveComponent("ProgressBar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Button, {
      disabled: _ctx.currentStep === 1,
      type: _ctx.ButtonType.Neutral,
      "icon-left": "chevron-left",
      "mobile-collapse": "",
      onClick: _ctx.prev
    }, {
      default: _withId(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["disabled", "type", "onClick"]),
    _createVNode("span", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_ProgressBar, {
        max: _ctx.maxStep,
        value: _ctx.currentStep
      }, null, 8, ["max", "value"])
    ]),
    _createVNode(_component_Button, {
      disabled: !_ctx.canNext,
      type: _ctx.ButtonType.Primary,
      "icon-right": "chevron-right",
      "mobile-collapse": "",
      onClick: _ctx.next
    }, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.nextText), 1 /* TEXT */)
      ]),
      _: 1
    }, 8, ["disabled", "type", "onClick"])
  ]))
})